import { Outlet, useNavigate } from "react-router-dom";
import SidebarNavigation from "../components/layout/sidebar-navigation";
import { useContext, useEffect } from "react";
import AuthContext from "../store/auth/auth-context";
import Cookie from "js-cookie";
import { CssBaseline } from "@mui/material";
import TopBarNavigation from "../components/layout/top-bar";
import { Box } from "@mui/system";

const RootLayout = () => {
  const authCxt = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = Cookie.get("accessToken");
    const refreshToken = Cookie.get("refreshToken");
    if (!accessToken && !refreshToken) navigate("/login");
  }, [authCxt]);

  return (
    <>
      <Box sx={{ display: "flex", height: "100vh" }}>
        <CssBaseline />
        <SidebarNavigation />
        <TopBarNavigation />
        <Outlet />
      </Box>
    </>
  );
};

export default RootLayout;
